'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { searchHref } from '@/lib/links';
import type { Locale } from '@/lib/i18n';

export function HeroSearch({ locale }: { locale: Locale }) {
  const [query, setQuery] = useState('');
  const router = useRouter();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      router.push(searchHref(locale, query.trim()));
    }
  };

  return (
    <form onSubmit={handleSearch} className="relative w-full group">
      <div className="relative flex items-center">
        <Search className="absolute left-3.5 h-4 w-4 text-muted-foreground/50 group-focus-within:text-primary transition-colors" />
        <Input
          type="text"
          placeholder="Search for AI legal research, tax automation..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="w-full h-12 pl-10 pr-28 bg-card/85 border-primary/20 text-foreground placeholder:text-muted-foreground/50 rounded-xl focus:ring-primary/40 focus:border-primary/40 transition-all text-sm"
        />
        <Button 
          type="submit"
          className="absolute right-1.5 h-9 px-5 bg-primary hover:bg-primary/90 text-primary-foreground text-sm font-semibold rounded-lg transition-all"
        >
          Search
        </Button>
      </div>
    </form>
  );
}
